import '../DataCollectionGroupPanel.css'

import { Table, td, tr } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'

export default class FirstSectionPanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  render() {
    return (
      <Table>
        <tbody>
          {this.getRow('Protein', this.props.datacollectiongroup.acronym)}
          {this.getRow('Sample', this.props.datacollectiongroup.sampleName)}
          {this.getRow('Shipment', this.props.datacollectiongroup.shippingName)}
          {this.getRow('Parcel', this.props.datacollectiongroup.parcelName)}
          {this.getRow(
            'Container / Position',
            this.props.datacollectiongroup.containerName + '/' + this.props.datacollectiongroup.sampleLocation
          )}
          {this.getRow('Beamline location', this.props.datacollectiongroup.beamlineLocation)}
          {this.getRow('Sample Changer Location', this.props.datacollectiongroup.sampleChangerLocation)}
        </tbody>
      </Table>
    )
  }
}

FirstSectionPanel.propTypes = {
  acronym: PropTypes.string,
  sampleName: PropTypes.string,
  shippingName: PropTypes.string,
  parcelName: PropTypes.string,
  containerName: PropTypes.string,
  sampleLocation: PropTypes.string,
  beamlineLocation: PropTypes.string,
  sampleChangerLocation: PropTypes.string,
}
